import axios from "axios"
import { getItem } from '../config/localStorage';

const DotNet_API_BASE_URL = process.env.REACT_APP_API_BACKEND_BASE_URL;
const Python_API_BASE_URL = process.env.REACT_APP_BACKEND_PYTHON_BASE_URL;


/** dot Net API CAll start */
export const axiosInstance = axios.create({
    baseURL: DotNet_API_BASE_URL,
    headers: {
        "Content-type": "application/json",
    },
})

const AUTH_TOKEN = getItem("token");

axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${AUTH_TOKEN}`;

axiosInstance.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if ((error.message === 'Network Error') || (error.response.status === 401)) {
        localStorage.clear();
        window.location.href = "/home"
    }
    return Promise.reject(error);
});

/** dot Net API CAll end */

/** Python API CAll start */

export const pythonAxiosInstance = axios.create({
    baseURL: Python_API_BASE_URL,
    headers: {
        "Content-type": "application/json",
    },
})

const PYTHON_AUTH_TOKEN = getItem("authToken");

pythonAxiosInstance.defaults.headers.common['Authorization'] = `Bearer ${PYTHON_AUTH_TOKEN}`;

pythonAxiosInstance.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if ((error.message === 'Network Error') || (error.response.status === 401)) {
        localStorage.clear();
        window.location.href = "/home"
    }
    return Promise.reject(error);
});

/** Python API CAll end */

/** Use It for without login .net API CAll start */

export const nonRestrictedApiAxiosInstance = axios.create({
    baseURL: DotNet_API_BASE_URL,
    headers: {
        "Content-type": "application/json",
    },
})

nonRestrictedApiAxiosInstance.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if ((error.message === 'Network Error') || (error.response.status === 401)) {
        // localStorage.clear();
        // window.location.href = "/home"
    }
    return Promise.reject(error);
});

/** Use It for without login .net API CAll end */




